module.exports = __webpack_public_path__ + "static/media/plumber.42bd824c.jpg";